<div class="mb-8">
  <app-form-title-with-subtitle>
    <span title>Zarejestruj się jako firma</span>
    <span subtitle>Załóż konto za darmo i zacznij korzystać z portalu</span>
  </app-form-title-with-subtitle>
</div>

<div class="mb-8">
  <app-alerts />

  @if (isFormVisible()) {
    <app-sign-up-as-company-form
      (submitClickEvent)="handleSubmitClickEvent($event)" />
  } @else {
    <div class="text-center">
      <p-button
        (onClick)="handleNavigateToSignInPageClick()"
        appPrimengButton
        label="Przejdź do strony logowania" />
    </div>
  }
</div>
